import { render, staticRenderFns } from "./changeFacePage.vue?vue&type=template&id=e5b40270&scoped=true"
import script from "./changeFacePage.vue?vue&type=script&lang=js"
export * from "./changeFacePage.vue?vue&type=script&lang=js"
import style0 from "./changeFacePage.vue?vue&type=style&index=0&id=e5b40270&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b40270",
  null
  
)

export default component.exports